import {supportedLanguages, ThemeName} from "../config/config";

export const isPositiveFloat = (str: string) => {
	const num = parseFloat(str);
	return !isNaN(num) && num > 0 && str.trim() === num.toString();
};

export const isWholeNumber = (str: string) => {
	return /^(0|[1-9]\d*)$/.test(str);
};

export const isPositiveInteger = (str: string) => {
	return /^([1-9]\d*)$/.test(str);
};

export const setPageTheme = async (themeName: ThemeName) => {
	try {
		await require(`../themes/${themeName}.css`);
		document.documentElement.setAttribute('data-theme', themeName);
	} catch (error) {
		console.error(`Failed to load theme: ${themeName}`, error);
	}
};

export const setPageLanguage = () => {
	const locale = navigator.language.toLowerCase();
	let finalLocale = supportedLanguages[0];
	supportedLanguages.forEach(lang => {
		if(locale === lang) {
			finalLocale = lang;
			return;
		} else if(locale.includes(lang)) {
			finalLocale = lang;
			return;
		}
	});
	document.documentElement.setAttribute('data-language', finalLocale);
}